import React, { FC } from "react";

import { startCase } from "lodash";

import { ParticipantStatus, UserStatus } from "@api/graphql";
import { StatusBadge } from "@components/table/StatusBadge";

import styles from "./ParticipantStatusBadge.module.scss";

interface ParticipantStatusBadgeProps {
  status: ParticipantStatus | UserStatus | boolean;
}
export const ParticipantStatusBadge: FC<ParticipantStatusBadgeProps> = ({ status }) => {
  let normalizedStatus: string;

  if (typeof status === "boolean") {
    normalizedStatus = status ? ParticipantStatus.DECEASED : ParticipantStatus.ACTIVE;
  } else {
    normalizedStatus = status;
  }
  const formattedStatus = startCase(normalizedStatus.toLowerCase());
  return (
    <StatusBadge cellClassName={normalizedStatus.toLowerCase()} cellValue={formattedStatus} customStyle={styles} />
  );
};
